import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { DropdownValue } from "../shared/dropdown.model";
import { FilterItemsService } from "../shared/filter-items.service";
import { CampaignsFilterModel } from "./campaign-filter.model";
import { StorageService } from "../core/services/index";
import { consts } from "../shared/consts";
import { ActivatedRoute } from "@angular/router";
import { MediationFilters } from "../mediation/mediation.filters";
import { ProviderTreeSelectionModalComponent } from "../shared/providers-tree-selection-modal.component";
import { DateHelperService } from '../core/services/date-helper.service';
import { BrowserService } from '../core/services/browser.service';

@Component({
    moduleId: module.id,
    selector: 'campaigns-filter',
    templateUrl: 'campaigns-filter.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CampaignsFilterComponent implements OnInit {
    disabledButtons: boolean = true;
    public availableValues: Array<DropdownValue> = [];
    public availablePrefix: string = "Available";
    public defaultAvailableSelection: DropdownValue;
    public countryValues: Array<DropdownValue> = [];
    public defaultCountrySelection: DropdownValue;
    public countryPrefix: string = "Country";
    public brand: string = '';
    public product: string = '';
    public dsp: string = '';
    public ssp: string = '';
    public tradingDesk: string = '';
    public providerValues: Array<DropdownValue> = [];
    public providerPrefix: string = "Provider";
    public defaultProviderSelection: DropdownValue;
    private filters: CampaignsFilterModel;
    public startDate: Date;
    public endDate: Date;
    public dateError: string;

    @Output() filterChanged: EventEmitter<CampaignsFilterModel>;
    @Input() showProviders: boolean;
    @ViewChild("providerTreeSelectionModal") providerTreeSelectionModalComponent: ProviderTreeSelectionModalComponent

    constructor(
        private filterItemsService: FilterItemsService,
        private storageService: StorageService,
        private route: ActivatedRoute,
        private el: ElementRef,
        private dateHelperService: DateHelperService,
        private browserSerive: BrowserService) {
        this.showProviders = true;
        this.filterChanged = new EventEmitter<CampaignsFilterModel>();
    }

    ngOnInit() {
        this.availableValues = this.filterItemsService.getAvailableValues();
        this.countryValues = this.filterItemsService.getCountries(true);
        if (this.showProviders)
            this.providerValues = this.filterItemsService.getNonConfigurableProviders(true);
        this.initFilters();
        this.disable();
    }

    disable() {
        this.disabledButtons = true;
    }
    enable() {
        this.disabledButtons = false;
    }

    public onAvailableValueChanged(item: DropdownValue) {
        this.filters.isAvailable = this.getisAvailable(item.value);
    }

    public onCountryValueChanged(item: DropdownValue) {
        if (item.value === 0)
            this.filters.countryIds = this.filterItemsService.getCountryIds();
        else {
            this.filters.countryIds = new Array<number>();
            this.filters.countryIds.push(item.value);
        }
    }

    public onProviderValueChanged(providerIds: number[]) {
        if (this.showProviders) {
            this.filters.providerIds = providerIds;
            if (this.filterItemsService.getNonConfigurableProvidersIds().length === providerIds.length)
                this.storageService.remove(consts.ProviderIdsFilterStorageKey);
            else {
                this.storageService.set(consts.ProviderIdsFilterStorageKey, this.filters.providerIds);
                this.storageService.set(consts.CampaignFilterStorageKey, this.filters);
            }
        }
    }

    public onResetFilters(event) {
        //remove values from storage
        this.storageService.remove(consts.CampaignFilterStorageKey);
        this.storageService.remove(consts.PublisherIdsFilterStorageKey);
        this.storageService.remove(consts.MediationFilterStorageKey);
        this.storageService.remove(consts.ProviderIdsFilterStorageKey);
        //reset selected values in filters
        this.defaultAvailableSelection = this.filterItemsService.getDefaultIsAvailableSelection();
        this.defaultCountrySelection = this.filterItemsService.getDefaultCountrySelection(true);
        this.providerTreeSelectionModalComponent.resetSelection();
        this.resetDatePickers();
        this.filters.startDate = null;
        this.filters.endDate = null;
        this.startDate = null;
        this.endDate = null;
        this.brand = '';
        this.product = '';
        this.dsp = '';
        this.ssp = '';
        this.tradingDesk = '';
        this.filters = new CampaignsFilterModel(this.brand, this.product, this.dsp, this.ssp, this.tradingDesk, this.getisAvailable(this.defaultAvailableSelection.value),
            this.filterItemsService.getCountryIds(), this.filterItemsService.getNonConfigurableProvidersIds(), this.filterItemsService.getPublishersIds(), null, null);
        this.filterChanged.emit(this.filters);
    }

    public onPublishersChanged(publisherIds) {
        this.filters.publisherIds = publisherIds;
        if (this.filterItemsService.getPublishersIds().length === publisherIds.length)
            this.storageService.remove(consts.PublisherIdsFilterStorageKey);
        else {
            this.storageService.set(consts.PublisherIdsFilterStorageKey, this.filters.publisherIds);
            this.storageService.set(consts.CampaignFilterStorageKey, this.filters);
        }
        this.filterChanged.emit(this.filters);
    }

    public onFilter(event) {
        this.filters.brand = this.brand;
        this.filters.product = this.product;
        this.filters.dsp = this.dsp;
        this.filters.ssp = this.ssp;
        this.filters.tradingDesk = this.tradingDesk;
        if (this.endDate != null && this.startDate > this.endDate) {
            this.dateError = consts.StartDateGreaterThanEndDateText;
            return;
        }
        this.dateError = null;
        this.filters.startDate = this.startDate;
        this.filters.endDate = this.endDate;
        this.storageService.set(consts.CampaignFilterStorageKey, this.filters);
        this.filterChanged.emit(this.filters);
    }

    public onDateClicked(event) {
        let ng2datePicker = this.el.nativeElement.querySelectorAll("ng2-datetime-picker[draggable='true']");
        $(ng2datePicker).attr('draggable', 'false');
    }

    public onMinDateChanged(newDate) {
        if (this.endDate && this.startDate) {
            let datePickers = this.el.nativeElement.querySelectorAll("[data-datepicker]");
            if (datePickers && datePickers[1]) {
                datePickers[1].value = '';
                this.endDate = null;
            }
        }
    }

    private getisAvailable(availableId: number): boolean {
        switch (availableId) {
            case 1:
                return true;
            case 2:
                return false;
            default:
                return null;
        }
    }

    private getisAvailableValue(isAvailable: boolean): number {
        switch (isAvailable) {
            case true:
                return 1;
            case false:
                return 2;
            default:
                return null;
        }
    }

    private initFilters(): void {
        let filtersFromStorage = <CampaignsFilterModel>this.storageService.get(consts.CampaignFilterStorageKey);
        let providerIds = new Array<number>();
        if (this.showProviders) {
            this.defaultProviderSelection = this.filterItemsService.getDefaultNonConfigurableProviderSelection(true);
            providerIds = this.filterItemsService.getNonConfigurableProvidersIds();
        }
        this.defaultAvailableSelection = this.availableValues[0];
        this.defaultCountrySelection = this.filterItemsService.getDefaultCountrySelection(true);
        let mediationFilters = <MediationFilters>this.storageService.get(consts.MediationFilterStorageKey);
        if (mediationFilters != null) {
            //set values for campaign filters
            this.brand = '';
            this.product = '';
            this.dsp = '';
            this.ssp = '';
            this.tradingDesk = '';
            let tmpCountry = new Array<number>();
            if (mediationFilters.countryId != null) {
                tmpCountry.push(mediationFilters.countryId);
                this.defaultCountrySelection = this.countryValues.find(s => s.value === mediationFilters.countryId);
            }
            else tmpCountry = tmpCountry.concat(this.filterItemsService.getCountryIds());
            let tmpPublisher = new Array<number>();
            if (mediationFilters.publisherId != null)
                tmpPublisher.push(mediationFilters.publisherId);
            else tmpPublisher = tmpPublisher.concat(this.filterItemsService.getPublishersIds());
            let tmpProvider = new Array<number>();
            if (mediationFilters.providerId != null)
                tmpProvider.push(mediationFilters.providerId);
            else tmpProvider = tmpProvider.concat(this.filterItemsService.getNonConfigurableProvidersIds());
            if (mediationFilters.isLive != null)
                this.defaultAvailableSelection = this.availableValues.find(s => s.value == this.getisAvailableValue(mediationFilters.isLive));
            let tmpIsAvailable = mediationFilters.isLive != null ? mediationFilters.isLive : this.getisAvailable(this.availableValues[0].value);
            this.filters = new CampaignsFilterModel(this.brand, this.product, this.dsp, this.ssp, this.tradingDesk, tmpIsAvailable, tmpCountry, tmpProvider, tmpPublisher, null, null);
        } else {
            if (filtersFromStorage) {
                this.brand = filtersFromStorage.brand;
                this.product = filtersFromStorage.product;
                this.dsp = filtersFromStorage.dsp;
                this.ssp = filtersFromStorage.ssp;
                this.tradingDesk = filtersFromStorage.tradingDesk;
                let filterPublishers = new Array<number>();
                if (filtersFromStorage.publisherIds.length > 0) filterPublishers = filterPublishers.concat(filtersFromStorage.publisherIds);
                else filterPublishers = filterPublishers.concat(this.filterItemsService.getPublishersIds());
                if (filtersFromStorage.countryIds.length === 1)
                    this.defaultCountrySelection = this.countryValues.find(s => s.value === filtersFromStorage.countryIds[0]);
                if (filtersFromStorage.isAvailable != null)
                    this.defaultAvailableSelection = this.availableValues.find(s => s.value === this.getisAvailableValue(filtersFromStorage.isAvailable));
                else this.defaultAvailableSelection = this.availableValues[2];
                let tmpStart = null;
                if (filtersFromStorage.startDate != null) tmpStart = this.dateHelperService.formatDayAndMonth(filtersFromStorage.startDate);
                let tmpEnd = null;
                if (filtersFromStorage.endDate != null) tmpEnd = this.dateHelperService.formatDayAndMonth(filtersFromStorage.endDate);

                this.filters = new CampaignsFilterModel(this.brand, this.product, this.dsp, this.ssp, this.tradingDesk, this.getisAvailable(this.defaultAvailableSelection.value),
                    filtersFromStorage.countryIds, filtersFromStorage.providerIds, filterPublishers, tmpStart, tmpEnd);
            }
            else {
                this.brand = '';
                this.product = '';
                this.dsp = '';
                this.ssp = '';
                this.tradingDesk = '';
                this.filters = new CampaignsFilterModel(this.brand, this.product, this.dsp, this.ssp, this.tradingDesk, this.getisAvailable(this.defaultAvailableSelection.value),
                    this.filterItemsService.getCountryIds(), this.filterItemsService.getNonConfigurableProvidersIds(), this.filterItemsService.getPublishersIds(), null, null);
            }
        }
        this.filterChanged.emit(this.filters);
    }

    private resetDatePickers() {
        let datePickers = this.el.nativeElement.querySelectorAll("[data-datepicker]");
        if (this.browserSerive.isIE())
            datePickers = [datePickers];
        if (datePickers) {
            //forEach not supported in IE
            datePickers.forEach(element => {
                element.value = '';
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/campaigns/campaigns-filter.component.ts